module.exports = __webpack_public_path__ + "static/media/cosmetic2.85b18050.jpg";